<template>
  <div class="col">
    <div class="row">
      <div class="col-xl-4 col-md-6" v-if="hasPermission('access cards_topics') || hasPermission('view cards_topics')">
        <router-link to="/topics_card">
          <stats-card
            :title="`${localization('Cards Topics')}`"
            style="min-height: 160px; text-transform: uppercase"
          >
            <div slot="header" class="icon-warning">
              <i class="fa fa-list text-info"></i>
            </div>
          </stats-card>
        </router-link>
      </div>
      <div class="col-xl-4 col-md-6" v-if="hasPermission('access students_notebook')">
        <router-link to="/students_notebook">
          <stats-card
            :title="`${localization('Students Notebook')}`"
            style="min-height: 160px; text-transform: uppercase"
          >
            <div slot="header" class="icon-warning">
              <i class="fa fa-book text-info"></i>
            </div>
          </stats-card>
        </router-link>
      </div>
      <div class="col-xl-4 col-md-6" v-if="hasPermission('access strategies_card') || hasPermission('view strategies_card')">
        <router-link to="/strategies_card">
          <stats-card
            :title="`${localization('Strategies Card')}`"
            style="min-height: 160px; text-transform: uppercase"
          >
            <div slot="header" class="icon-warning">
              <i class="fa fa-lightbulb-o text-info"></i>
            </div>
          </stats-card>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { StatsCard } from "../../components";

export default {
  name: "LaunchCardsManagement",
  components: {
    StatsCard
  }
};
</script>

<style scoped></style>
